const fieldLabels = {
  english: {
    districtNumber: "Total Jila sam Mahanagar/ Bhag",
    districtNumberJilaKendra: "Total Jila Kendra",
    districtNumberAnyaNagar: "Total Any Nagar",
    settlementNumber: "Number of Sewa Basti within",
    serviceSettlementNumber: "Number of Sewa basti having sewa karya",
    businessCollegeNumber: "Number of Vyavsayee & Mahavidyalay shaka & Milan",
    settlementBranchNumber: "Number of Sevabasti Palak Shakha & Millan",
    serviceWorkerBranchNumber:
      "Number of Shakha & Milan having Sewa Karyakarta",
       kulMahanagariyNagarSankhya: "Total Number of Metropolitan Cities",
    sevaKaryayuktMahanagariyNagarSankhya: "Number of Metropolitan Cities with Functional Services",
    kulKhand: "Total Number of Blocks",
    sevaYuktKhand: "Number of Blocks with Services",
    totalServiceWorkers: "Total Sewa Karyakarta",
    totalServiceWork:
      "Total sewa karya in Mahanagar(Including sewa karya of Sewa Sanstha)",
    totalServiceWorkJilaKendra:
      "Total sewa karya in JilaKendra(Including sewa karya of Sewa Sanstha)",
    totalServiceWorkAnyaNagar:
      "Total sewa karya in AnyaNagar(Including sewa karya of Sewa Sanstha)",
    serviceSettlementsAmongThem:
      "Number of Service Settlements among them (if specified)",
    branchesMeetingsWithServiceWorkers:
      "Number of Branches and Meetings with Service Workers",
    totalServiceWorkersInVillages: "Total Number of Service Workers",
    inmeinSevaBastiKiSankhya:
      "Number of Service Settlements among them (if specified)",
    sevaKaryakartaYuktShakhaVaMilanSankhya:
      "Number of Branches and Meetings with Service Workers",
    kulSevaKaryakarta: "Total Number of Service Workers",
    masikSevaBastiSamparkKarneWaliShakha:
      "Branches Conducting Monthly Service Settlement Contact",

    monthlyContactNumber:
      "Branch Conducting Monthly Service Settlement Contact",
    villagesAbove5000: "Villages with Population greater than 5000",
    businessVillageNumber: "Number of Grams having Vyavsayee or Farmer Shakha",
    serviceVillageNumber: "Number of Seva Karya yukt gram",
    totalServiceInVillages: "Total Sewa Karya",
    villagesOver5000: "Number of Gram with population above 5000",
    villagesUnder5000: " Number of Gram with Population less than 5000",
    villagesUnderess5000: "Number of Sevakarya yukt gram",
    totalServiceInVillagesBelow5000:
      "Total Service Work in Villages with Population less than 5000",
    selectNagar: "Select Nagar Type",
    mahanagar: "Mahanagar",
    jilaKendra: "Jila Kendra",
    anyaNagar: "Anya Nagar",
    selectLanguage: "Select Language : ",
    profile: "Profile",
    logout: "Logout",
    saveAsSubmit: "Save As Submit",
    Login: "Login",
    Username: "Username",
    EnterYourUsername: "Enter Your Username",
    Password: "Password",
    EnterYourPassword: "Enter Your Password",
    PrantName: "Prant Name",
    TotalVibhag: "Total Vibhag",
    TotalJila: "Total Jila",
    PrantUsers: "Prant Users",
    Prant: "Prant",
    FULLNAME: "Full Name",
    EMAIL: "Email",
    MOBILE: "Mobile No.",
    Dashboard: "Dashbaord",
    Reporting: "Reporting",
    ViewForm: "View From",
    ViewReporting: "View Reporting",
    UserManagement: "User Management",
    CreateUser: "Create User",
    ViewUsers: "View Users",
    ViewActivity: "View Activity",
    UserList: "Users List",
    UserType: "UserType",
    Kendra: "Kendra",
    Kshetra: "Kshetra",
    Vibhag: "Vibhag",
    Jila: "Jila",
    GrandTotal: "Grand Total",
    SelectUserType: "Select User Type",
    Phone: "Phone",
    Level: "Level",
    SelectLevel: "Select Level",
    SelectKshetra: "Select Kshetra",
    SelectPrant: "Select Prant",
    SelectVibhag: "Select Vibhag",
    SelectJila: "Select Jila",
    English: "English",
    Hindi: "Hindi",
    ToatalKshetra: "Toatal Kshetra",
    ToatalPrant: "Toatal Prant",
    NoDataAvailable: "No Data Available",
    SaveAsSubmit: "Save As Submit",
    Submit: "Submit",
    selectVibhag: "Select Vibhag ",
    selectJila: "Select Jila",
    KshetraPrantVibahgJila: "Kshetra / Prant / Vibahg / Jila",
    NoUsersAvailable: "No Users Available",
    TableVillagesOver5000: "More than 5000",
    TableVillagesUnder5000: "Less than 5000",
    AreaType: "Area Type",
    Viewer: "Viewer",
    Editor: "Editor",
    Admin: "Admin",
    // MAHANAGAR NEW FIELDS
    totalMetropolitanCities: "Total Number of Metropolitan Cities",
    functionalMetropolitanCities:
      "Number of Metropolitan Cities with Functional Services",
    // JILA KENDRA NEW FIELDS
    totalBlocks: "Total Number of Blocks",
    blocksWithServices: "Number of Blocks with Services",
    // VILLAGES OVER 5000 NEW FIELDS
    serviceSettlementsAmongThem:
      "Number of Service Settlements among them (if specified)",
    branchesMeetingsWithServiceWorkers:
      "Number of Branches and Meetings with Service Workers",
    totalServiceWorkersInVillages: "Total Number of Service Workers",
    // FORM TITLES
    form01: "Form - 01",
    form02: "Form - 02",
    // FORM 01/02 TABLE FIELD LABELS (ENGLISH)
    form01TableHeaders: [
      "S. No.",
      "1) Seva Sanskar-1",
      "2) Seva Sanskar-2",
      "3) Seva Basti Contact Aug/Sept 6 Month Branch",
      "4) Branch Running Seva Work",
      "5) Seva Work Conducted by Branch",
      "6) Seva Upkarmasheel Branch",
    ],
    form02TableHeaders: [
      "S. No.",
      "1) Seva Sanskar-1",
      "2) Seva Sanskar-2",
      "3) Seva Basti Contact Aug/Sept 6 Month Branch",
      "4) Branch Running Seva Work",
      "5) Seva Work Conducted by Branch",
      "6) Seva Upkarmasheel Branch",
    ],
    rssSevaDepartment: "R.S.S. – Seva Department",
    departmentDistrict: "Department/District",
    province: "Province",
    numberOfBranchesPerformingActivities:
      "Number of Branches Performing Activities",
    no: "No.",
    sevaSanskar1: "Seva Sanskar – 1",
    sevaSanskar2: "Seva Sanskar – 2",
    sevaBastiContact: "Seva Basti Contact",
    augustSeptember: "August/September",
    branchesVisiting6Plus: "Branches Visiting 6+ Times Annually",
    branchesConductingServiceActivities:
      "Branches Conducting Service Activities",
    numberOfServiceActivitiesConducted:
      "Number of Service Activities Conducted by Branch",
    serviceInitiativeBranch: "Service Initiative Branch",
    sevaShikshanWorkReport: "Seva Shikshan Karya Vritt (Prapatra - 03)",
    october2025: "October 2025",
    // Tooltips/Descriptions
    sevaSanskar1Desc:
      "Branches that practice Subhashit, Amritvachan, and songs on the weekly Seva day",
    sevaSanskar2Desc:
      "Branches that organize service project info, service stories, experiences, or discussions",
    sevaBastiContactDesc:
      "Branches visiting adopted service settlements in Aug/Sep, and 6+ times a year",
    branchesConductingServiceActivitiesDesc:
      "Branches conducting daily/weekly service without honorarium",
    numberOfServiceActivitiesConductedDesc:
      "Daily/weekly permanent service works without honorarium",
    serviceInitiativeBranchDesc:
      "Branches with minimum two service initiatives (health camps, literature distribution, etc.)",
    note: "Note:",
    noteText:
      "Enter only numbers in all columns. Write all numbers in English. Send district-wise consolidated report to province center.",
    period: "Period: Oct 2024 – Sep 2025",
    // Table headers (with sub-columns)
    form03TableHeaders: [
      "No.",
      "Seva Sanskar – 1",
      "Seva Sanskar – 2",
      {
        main: "Seva Basti Contact",
        subs: ["August/September", "Branches Visiting 6+ Times Annually"],
      },
      "Branches Conducting Service Activities",
      "Number of Service Activities Conducted by Branch",
      "Service Initiative Branch",
    ],
  },

  hindi: {
    districtNumber: "जिला सम महानगर/भाग संख्या",
    districtNumberJilaKendra: "कुल जिला केन्द्र ",
    kulMahanagariyNagarSankhya: "कुुल महानगरीय नगर संख्या",
    sevaKaryayuktMahanagariyNagarSankhya: "सेवा कार्ययुक्त महानगरीय नगर संख्या",
    kulKhand: "कुल खण्ड",
    sevaYuktKhand: "सेवा युक्त खण्ड",
    districtNumberAnyaNagar: "कुल अन्य नगर",
    settlementNumber: "इनमें सेवा बस्ती संख्या",
    serviceSettlementNumber: "सेवा कार्य युक्त सेवा बस्ती",
    serviceSettlementsAmongThem:
      "इनमें सेवा बस्ती की संख्या (यदि निश्चित है तो)",
    branchesMeetingsWithServiceWorkers:
      "सेवा कार्यकर्ता युक्त शाखा व मिलन संख्या",
    totalServiceWorkersInVillages: "कुल सेवा कार्यकर्ता",
    inmeinSevaBastiKiSankhya: "इनमें सेवा बस्ती की संख्या (यदि निश्चित है तो)",
    sevaKaryakartaYuktShakhaVaMilanSankhya:
      "सेवा कार्यकर्ता युक्त शाखा व मिलन संख्या",
    kulSevaKaryakarta: "कुल सेवा कार्यकर्ता",
    masikSevaBastiSamparkKarneWaliShakha:
      "मासिक सेवा बस्ती संपर्क करने वाली शाखा",
    businessCollegeNumber: "व्यवसायी व महाविद्यालय शाखा व मिलन संख्या",
    settlementBranchNumber: "सेवा बस्ती पालक शाखा व मिलन संख्या",
    serviceWorkerBranchNumber: "सेवा कार्यकर्ता युक्त शाखा व मिलन संख्या",
    totalServiceWorkers: "कुल सेवा कार्यकर्ता",
    totalServiceWork:
      "महानगर में कुल सेवा कार्य (सेवा संस्थाओं के सेवा कार्य सहित)",
    totalServiceWorkJilaKendra:
      "जिला में कुल सेवा कार्य (सेवा संस्थाओं के सेवा कार्य सहित)",
    totalServiceWorkAnyaNagar:
      "अन्य नगर में कुल सेवा कार्य (सेवा संस्थाओं के सेवा कार्य सहित)",
    monthlyContactNumber:
      "मासिक सेवा बस्ती संपर्क करने वाली शाखा व मिलन संख्या",
    villagesAbove5000: "5000 या उससे अधिक जनसंख्या के ग्रामों की संख्या",
    businessVillageNumber: "इनमें व्यवसायी या कृषक शाखायुक्त ग्राम",
    serviceVillageNumber: "इनमें सेवा कार्ययुक्त ग्राम",
    totalServiceInVillages: "इनमें कुल सेवा कार्य",
    villagesOver5000: "5000 से अधिक जनसंख्या के ग्राम",
    villagesUnder5000: "5000 से कम जनसंख्या के ग्राम ",
    villagesUnderess5000: "5000 से कम जनसंख्या के सेवा युक्त ग्राम संख्या",
    totalServiceInVillagesBelow5000: "इनमें कुल सेवा कार्य",
    selectNagar: "नगर प्रकार चुनें",
    mahanagar: "महानगर",
    jilaKendra: "जिलाकेंद्र",
    anyaNagar: "अन्य नगर",
    selectLanguage: "भाषा चयन करें :",
    profile: "प्रोफ़ाइल",
    logout: "लॉगआउट",
    saveAsSubmit: "सहेजें और सबमिट करें",
    Login: "लॉगिन",
    Username: "उपयोगकर्ता नाम",
    EnterYourUsername: "अपना उपयोगकर्ता नाम दर्ज करें",
    Password: "पासवर्ड",
    EnterYourPassword: "अपना पासवर्ड दर्ज करें",
    PrantName: "प्रांत का नाम",
    TotalVibhag: "कुल विभाग",
    TotalJila: "कुल जिला",
    PrantUsers: "प्रांत के उपयोगकर्ता",
    Prant: "प्रांत",
    FULLNAME: "पूरा नाम",
    EMAIL: "ईमेल",
    MOBILE: "मोबाइल नंबर",
    Dashboard: "डैशबोर्ड",
    Reporting: "रिपोर्टिंग",
    ViewForm: "फॉर्म देखें",
    ViewReporting: "रिपोर्टिंग देखें",
    UserManagement: "उपयोगकर्ता प्रबंधन",
    CreateUser: "उपयोगकर्ता बनाएं",
    ViewUsers: "उपयोगकर्ताओं को देखें",
    ViewActivity: "View Activity",
    UserList: "उपयोगकर्ताओं की सूची",
    UserType: "उपयोगकर्ता प्रकार",
    Kendra: "केंद्र",
    Kshetra: "क्षेत्र",
    Vibhag: "विभाग",
    Jila: "जिला",
    GrandTotal: "कुल योग",
    SelectUserType: "उपयोगकर्ता प्रकार चुनें",
    Phone: "फोन",
    Level: "स्तर",
    SelectLevel: "स्तर चुनें",
    SelectKshetra: "क्षेत्र चुनें",
    SelectPrant: "प्रांत चुनें",
    SelectVibhag: "विभाग चुनें",
    SelectJila: "जिला चुनें",

    English: "English",
    Hindi: "हिंदी",
    ToatalKshetra: "कुल क्षेत्र",
    ToatalPrant: "कुल प्रांत",
    NoDataAvailable: "कोई डेटा उपलब्ध नहीं है",
    SaveAsSubmit: "सहेजें और सबमिट करें",
    Submit: "सबमिट करें",
    selectVibhag: "विभाग चयन करें ",
    selectJila: "जिला चयन करें",
    KshetraPrantVibahgJila: "क्षेत्र / प्रांत / विभाग / जिला",
    Name: "नाम",
    Username: "उपयोगकर्ता नाम",
    UserType: "उपयोगकर्ता प्रकार",
    AreaType: "क्षेत्र प्रकार",
    NoUsersAvailable: "कोई उपयोगकर्ता उपलब्ध नहीं है",
    TableVillagesOver5000: "5000 से अधिक",
    TableVillagesUnder5000: "5000 से कम",
    Viewer: "दर्शक",
    Editor: "संपादक",
    Admin: "प्रशासक",
    // MAHANAGAR NEW FIELDS
    totalMetropolitanCities: "कुुल महानगरीय नगर संख्या",
    functionalMetropolitanCities: "सेवा कार्ययुक्त महानगरीय नगर संख्या",
    // JILA KENDRA NEW FIELDS
    totalBlocks: "कुल खण्ड",
    blocksWithServices: "सेवा युक्त खण्ड",
    // VILLAGES OVER 5000 NEW FIELDS
    serviceSettlementsAmongThem:
      "इनमें सेवा बस्ती की संख्या (यदि निश्चित है तो)",
    branchesMeetingsWithServiceWorkers:
      "सेवा कार्यकर्ता युक्त शाखा व मिलन संख्या",
    totalServiceWorkersInVillages: "कुल सेवा कार्यकर्ता",
    // FORM TITLES
    form01: "प्रपत्र - 01",
    form02: "प्रपत्र - 02",
    // FORM 01/02 TABLE FIELD LABELS (ENGLISH)
    form01TableHeaders: [
      "क्र.",
      "1) सेवा संस्कार-1",
      "2) सेवा संस्कार-2",
      "3) सेवा बस्ती सम्पर्क अगस्त/सितंबर 6 माह जाने वाली शाखा",
      "4) सेवा कार्य चलाने वाली शाखा",
      "5) शाखा द्वारा संचालित सेवा कार्य",
      "6) सेवा उपकर्मशील शाखा",
    ],
    form02TableHeaders: [
      "क्र.",
      "1) सेवा संस्कार-1",
      "2) सेवा संस्कार-2",
      "3) सेवा बस्ती सम्पर्क अगस्त/सितंबर 6 माह जाने वाली शाखा",
      "4) सेवा कार्य चलाने वाली शाखा",
      "5) शाखा द्वारा संचालित सेवा कार्य",
      "6) सेवा उपकर्मशील शाखा",
    ],
    rssSevaDepartment: "रा.स्व.संघ - सेवा विभाग",
    departmentDistrict: "विभाग/जिला",
    province: "प्रांत",
    numberOfBranchesPerformingActivities: "करनेवाली शाखाओं की संख्या लिखना",
    no: "क्र",
    sevaSanskar1: "सेवा संस्कार-1",
    sevaSanskar2: "सेवा संस्कार-2",
    sevaBastiContact: "सेवा बस्ती सम्पर्क",
    augustSeptember: "अगस्त/सितंबर",
    branchesVisiting6Plus: "6 माह जाने वाली शाखा",
    branchesConductingServiceActivities: "सेवा कार्य चलाने वाली शाखा",
    numberOfServiceActivitiesConducted: "शाखा द्वारा संचालित सेवा कार्य",
    serviceInitiativeBranch: "सेवा उपकर्मशील शाखा",
    sevaShikshanWorkReport: "सेवा शिक्षण कार्य वृत्त (प्रपत्र - 03)",
    october2025: "अक्टुबर 2025",
    // Tooltips/Descriptions
    sevaSanskar1Desc:
      "साप्ताहिक सेवा दिवस पर सुभाषित, अमृतवचन, गीत का अभ्यास करने वाली शाखाएँ",
    sevaSanskar2Desc:
      "सेवा कार्य/प्रकल्प जानकारी, सेवा कथा, महापुरूषों के जीवन का सेवा का संस्मरण, अनुभव कथन या चर्चा के कार्यक्रम करने वाली शाखाएं",
    sevaBastiContactDesc:
      "अगस्त/सितंबर के कॉलम में अगस्त अथवा सितंबर माह में दत्तक/गोद ली हुई सेवा बस्ती में तथा दूसरे कॉलम में वर्ष में 6 या अधिक बार सम्पर्क करने वाली शाखाएं",
    branchesConductingServiceActivitiesDesc:
      "बिना मानधन के दैनिक/साप्ताहिक स्थाई सेवा कार्य चलाने वाली शाखाओं की संख्या",
    numberOfServiceActivitiesConductedDesc:
      "बिना मानधन या मानदेयी कार्यकर्ता के दैनिक/साप्ताहिक स्थाई सेवा कार्यों की संख्या",
    serviceInitiativeBranchDesc:
      "इस साल न्यूनतम दो सेवा उपक्रम किया ऐसी शाखाएँ (आरोग्य शिविर, शिक्षा उपयोगी साहित्य वितरण, बस्ती मे सहभोज, महापुरुष पुण्यस्मरण दिन, भजन आदि)",
    note: "सूचना:",
    noteText:
      "सेवा शिक्षण कार्य वृत्त के सभी स्तंभों में केवल आंकडे लिखने है। कृपया ध्यान दे, सभी आंकडे अंग्रेजी में लिखें। प्रांत में जिलाशः लेकर केन्द्र को प्रांत योग का वृत्त भेजे।",
    period: "अक्टुबर 2024 से सितंबर 2025 के बीच का वृत्त",
    // Table headers (with sub-columns)
    form03TableHeaders: [
      "क्र.",
      "सेवा संस्कार-1",
      "सेवा संस्कार-2",
      {
        main: "सेवा बस्ती सम्पर्क",
        subs: ["अगस्त/सितंबर", "6 माह जाने वाली शाखा"],
      },
      "सेवा कार्य चलाने वाली शाखा",
      "शाखा द्वारा संचालित सेवा कार्य",
      "सेवा उपकर्मशील शाखा",
    ],
  },
};

export default fieldLabels;
